import React from 'react';
import { useTranslation } from 'react-i18next';
import { User } from 'lucide-react';

const NameInput = ({ 
  firstName = '', 
  lastName = '', 
  onFirstNameChange, 
  onLastNameChange, 
  firstNameError, 
  lastNameError,
  required = false 
}) => {
  const { t } = useTranslation();
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
      {/* First Name */}
      <div>
        <label htmlFor="firstName" className="block text-sm font-medium text-gray-700 mb-2">
          {t('booking.firstName')} {required && <span className="text-red-500">*</span>}
        </label>
        <div className="relative">
          <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
            <User className="h-5 w-5 text-gray-400" />
          </div>
          <input
            type="text"
            id="firstName"
            value={firstName}
            onChange={(e) => onFirstNameChange(e.target.value)}
            placeholder="John"
            className={`block w-full pl-10 pr-3 py-3 border ${
              firstNameError ? 'border-red-300 focus:ring-red-500 focus:border-red-500' : 'border-gray-300 focus:ring-blue-500 focus:border-blue-500'
            } rounded-lg shadow-sm focus:ring-2 transition-all`}
          />
        </div>
        {firstNameError && (
          <p className="mt-2 text-sm text-red-600 flex items-center gap-1">
            <span>⚠️</span>
            {firstNameError}
          </p>
        )}
      </div>

      {/* Last Name */}
      <div>
        <label htmlFor="lastName" className="block text-sm font-medium text-gray-700 mb-2">
          {t('booking.lastName')} {required && <span className="text-red-500">*</span>}
        </label>
        <div className="relative">
          <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
            <User className="h-5 w-5 text-gray-400" />
          </div>
          <input
            type="text"
            id="lastName"
            value={lastName}
            onChange={(e) => onLastNameChange(e.target.value)}
            placeholder="Doe"
            className={`block w-full pl-10 pr-3 py-3 border ${
              lastNameError ? 'border-red-300 focus:ring-red-500 focus:border-red-500' : 'border-gray-300 focus:ring-blue-500 focus:border-blue-500'
            } rounded-lg shadow-sm focus:ring-2 transition-all`}
          />
        </div>
        {lastNameError && (
          <p className="mt-2 text-sm text-red-600 flex items-center gap-1">
            <span>⚠️</span>
            {lastNameError}
          </p>
        )}
      </div>
    </div>
  );
};

export default NameInput;
